import React from 'react';
import { useTranslation } from 'react-i18next';
import './PostDeletedByAdminModal.css';

const PostDeletedByAdminModal = ({ isOpen, onClose, reasons, reason, reasonLabels }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === 'rtl';

  if (!isOpen) return null;

  const hasReasons = Array.isArray(reasons) && reasons.length > 0;
  const hasLegacyReason = typeof reason === 'string' && reason.trim().length > 0;

  const getReasonDisplay = (value) => {
    if (reasonLabels && typeof reasonLabels === 'object' && reasonLabels[value]) {
      return reasonLabels[value];
    }
    return t(`reportReasons.${value}`, value);
  };

  return (
    <div className="post-deleted-modal-overlay" onClick={onClose}>
      <div className="post-deleted-modal" dir={isRTL ? 'rtl' : 'ltr'} onClick={(e) => e.stopPropagation()}>
        <button className="post-deleted-modal-close" onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className="post-deleted-modal-icon">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#dc2626" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
            <line x1="12" y1="9" x2="12" y2="13" />
            <circle cx="12" cy="17" r="0.8" fill="#dc2626" stroke="none" />
          </svg>
        </div>

        <h2 className="post-deleted-modal-title">
          {t('notifications.postDeletedByAdmin.title', 'Post Deleted')}
        </h2>

        <div className="post-deleted-modal-body">
          <p className="post-deleted-modal-intro">
            {t(
              'notifications.postDeletedByAdmin.intro',
              'Your post has been deleted by our moderation team for the following reason(s):'
            )}
          </p>

          <div className="post-deleted-modal-reason">
            {hasReasons ? (
              <ul className="post-deleted-reasons-list">
                {reasons.map((r) => (
                  <li key={r}>
                    {getReasonDisplay(r)}
                    {r === 'other' && hasLegacyReason && (
                      <span className="post-deleted-reason-custom"> — {reason}</span>
                    )}
                  </li>
                ))}
              </ul>
            ) : hasLegacyReason ? (
              <p className="post-deleted-reason-legacy">{reason}</p>
            ) : (
              <p className="post-deleted-reason-legacy">
                {t('notifications.postDeletedByAdmin.noReason', 'No reason provided.')}
              </p>
            )}
          </div>

          <p className="post-deleted-modal-thanks">
            {t('notifications.postDeletedByAdmin.thanks', 'Thank you for your understanding.')}
          </p>
        </div>

        <button className="post-deleted-modal-ok" onClick={onClose}>
          {t('common.ok', 'OK')}
        </button>
      </div>
    </div>
  );
};

export default PostDeletedByAdminModal;
